import {
  type CartEntryCreateOrUpdateRequestRxByPrincipleData,
  type RxByPrincipleSelectableReason,
} from '@redteclab/api/clients/bully'

export const buildRxByPrincipleParams = (
  rxByPrincipleSelectedReason?: RxByPrincipleSelectableReason,
): CartEntryCreateOrUpdateRequestRxByPrincipleData | undefined => {
  if (!rxByPrincipleSelectedReason) {
    return undefined
  }

  return {
    reasonText: rxByPrincipleSelectedReason,
    selectedReason: rxByPrincipleSelectedReason,
  }
}
